<template>
  <b-card bg-variant="bg-light">
    <strong>{{ $t('choose-datetime-range') | capitalize }}</strong>
    <b-row>
      <b-col sm="12" md="6">
        <b-form-group
          :label="$t('from-date')"
        >
          <b-input-group>
            <flat-pickr
              :config="flatPickrConfig"
              v-model="dtRange.dtFrom"
              class="form-control"
              @on-close="onChange"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group
          :label="$t('to-date')"
        >
          <b-input-group>
            <flat-pickr
              :config="flatPickrConfig"
              v-model="dtRange.dtTo  "
              class="form-control"
              @on-close="onChange"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';

export default {
  name: 'DateTimeFilter',
  props: {
    value: {
      type: Array, // [ dtFrom: Date, dtTo: Date ]
    },
  },
  data() {
    return {
      flatPickrConfig: {
        enableTime: true,
        dateFormat: 'Y/m/d H:i',
        altFormat: 'd.m.Y H:i',
        altInput: true,
        time_24hr: true,
      },
      dtRange: {
        dtFrom: this.value[0],
        dtTo: this.value[1],
      },
    };
  },
  computed: {

  },
  methods: {
    onChange() {
      this.$emit('input', [new Date(this.dtRange.dtFrom), new Date(this.dtRange.dtTo)]);
    },
  },
  components: {
    flatPickr,
  },
  mounted() {
    this.onChange();
  },
};
</script>

<style scoped>

</style>
